import { useState } from 'react'
import { Button, Image } from 'antd'
import { useRouter } from 'next/router'
import useTranslation from '../../../hooks/useTranslation'
import { webAssets } from '../../../utils/webAssets'

import MenuContent from './MenuContent'
import NeedHelp from '../NeedHelp'
import NewRequest from '../../shared-components/modals/request/NewRequest'
import Plus from '../../svgs/Plus'

const Sidenav = ({ collapsed }) => {
  const { t } = useTranslation()
  const router = useRouter()

  const [open, setOpen] = useState(false)

  return (
    <>
      <div className='text-center mb-32'>
        <Image
          alt='smartcaf-logo'
          src={webAssets.logoDark}
          preview={false}
          className='!w-[6.5rem] !h-[4.5rem] cursor-pointer'
          onClick={() => router.push('/')}
        />
      </div>
      {!collapsed && (
        <Button
          icon={<Plus style='w-[0.875rem] ltr:mr-8 rtl:ml-8' />}
          className='btn-green text-sm font-semibold rounded-lg py-16 w-11/12 mx-auto h-auto flex items-center justify-center mb-40'
          onClick={() => setOpen(true)}
        >
          {t('sidenav.newRequest')}
        </Button>
      )}
      <MenuContent />
      {!collapsed && <NeedHelp {...{ open, setOpen }} />}

      <NewRequest {...{ open, setOpen }} />
    </>
  )
}

export default Sidenav
